import React from 'react';
import LegalPage from './LegalPage';

const PrivacyPolicy = () => (
  <LegalPage file="privacy-policy" logLabel="Privacy Policy" />
);

export default PrivacyPolicy;
